import React from 'react';
import {
  Button,
  LoadingButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IMappedAddress } from '../../../models/common/addresses';
import { IModalBasicProps } from '../../../models/common/modal';

interface IDefaultAddressModalProps extends IModalBasicProps {
  onSave: () => void;
  address: IMappedAddress;
  isLoading: boolean;
}

export const DefaultAddressModal: React.FC<IDefaultAddressModalProps> = ({
  hideModal,
  onSave,
  address,
  isLoading,
}: IDefaultAddressModalProps) => {
  const { addressLine1, addressLine2, city, state, zipCode } = address;

  return (
    <>
      <ModalHeader onClose={hideModal}>
        Confirm Your New Default Address
      </ModalHeader>
      <ModalBody>
        <Typography variant="body-base" weight="bold">
          New Default Address
        </Typography>
        <Typography data-qm-mask="" variant="body-base">
          {addressLine1}
        </Typography>
        <Typography data-qm-mask="" variant="body-base">
          {addressLine2}
        </Typography>
        <Typography data-qm-mask="">
          {city}, {state} {zipCode}
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <div className="sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="secondary" onClick={hideModal}>
            Cancel
          </Button>
          <LoadingButton
            variant="primary"
            onClick={onSave}
            loading={isLoading}
            data-testid="confirm-new-def-address-btn"
          >
            Set New Default Address
          </LoadingButton>
        </div>
      </ModalFooter>
    </>
  );
};

DefaultAddressModal.displayName = 'DefaultAddressModal';
